module.exports = __webpack_public_path__ + "static/media/IMG_6537.7f696240.JPG";